import React from "react";
import { PlayerType, ThemeType } from "../util/types";
import { DEFAULT_THEME } from "../util/consts";
import { motion } from "framer-motion";
import { playerColor } from "../util/utils";
import { Box } from "@mantine/core";
import DynamicText from "./DynamicText";

interface PlayerBadgesProps {
  players: PlayerType[];
  allowTwoRows?: boolean;
  horizontal?: boolean;
  theme?: ThemeType;
  judge?: string;
  showScores?: boolean;
  onRenderComplete?: () => void;
}

const PlayerBadges = ({
  players,
  allowTwoRows = true,
  horizontal = true,
  theme = DEFAULT_THEME,
  judge = "",
  showScores = false,
  onRenderComplete = async () => {},
}: PlayerBadgesProps) => {
  const badgeRow = (players: PlayerType[]) => {
    return players.map((p, i) => {
      return (
        <motion.div
          key={p.Name + i}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: i * 0.2 + 0.2 }}
          onAnimationComplete={async () => {
            if (i === players.length - 1) {
              await onRenderComplete;
            }
          }}
        >
          <DynamicText
            style={{
              border: "2px solid " + playerColor(p, judge, theme),
              borderRadius: "30px",
              color: playerColor(p, judge, theme),
              fontSize: 13,
              marginLeft: 2,
              marginBottom: 1,
              textAlign: "center",
              alignContent: "center",
              justifyContent: "center",
              justifyItems: "center",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              maxWidth: "calc(9vw)",
              minWidth: "calc(9vw)",
            }}
          >
            {p.Name + (showScores ? ` -- ${p.Score}` : "")}
          </DynamicText>
        </motion.div>
      );
    });
  };
  const splitPlayers = (players: PlayerType[]) => {
    if (players.length > 5 && allowTwoRows) {
      const firstRow = players.slice(0, players.length / 2);
      const secondRow = players.slice(players.length / 2);
      return (
        <>
          <Box
            style={{
              display: "flex",
              flexDirection: horizontal ? "row" : "column",
              justifyContent: "center",
              margin: "5px",
            }}
          >
            {badgeRow(firstRow)}
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: horizontal ? "row" : "column",
              justifyContent: "center",
              margin: "5px",
            }}
          >
            {badgeRow(secondRow)}
          </Box>
        </>
      );
    } else {
      return (
        <Box
          style={{
            display: "flex",
            flexDirection: horizontal ? "row" : "column",
            justifyContent: "center",
            margin: "5px",
          }}
        >
          {badgeRow(players)}
        </Box>
      );
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: horizontal ? "column" : "row",
        justifyContent: "center",
        margin: "5px",
      }}
    >
      {splitPlayers(players)}
    </Box>
  );
};

export default PlayerBadges;
